import { DateTime } from "luxon";

export const BUSINESS_TZ =
    "America/New_York";

/* TODAY IN ET */

export function getTodayET() {

    return DateTime
        .now()
        .setZone(BUSINESS_TZ)
        .toFormat("yyyy-MM-dd");
}

/* CURRENT ET DECIMAL HOUR */

export function getCurrentHourET() {

    const now =
        DateTime.now()
            .setZone(BUSINESS_TZ);

    return (
        now.hour +
        (now.minute / 60)
    );
}

/* VALID FUTURE DATE */

export function isFutureDateET(
    dateString
) {

    return (
        dateString >=
        getTodayET()
    );
}

/* VALID FUTURE SLOT */

export function isFutureSlotET(
    dateString,
    endHour
) {

    const today =
        getTodayET();

    /* FUTURE DATE */

    if (dateString > today) {
        return true;
    }

    /* PAST DATE */

    if (dateString < today) {
        return false;
    }

    /* TODAY */

    const currentHour =
        getCurrentHourET();

    return endHour > currentHour;
}

/* FORMAT DISPLAY DATE */

export function formatDisplayDate(
    dateString
) {

    return DateTime
        .fromISO(dateString, {
            zone: BUSINESS_TZ,
        })
        .toFormat(
            "cccc, MMMM d, yyyy"
        );
}

/* NEXT 7 DAYS */

export function getNext7DaysET() {

    const days = [];

    const today =
        DateTime.now()
            .setZone(BUSINESS_TZ);

    for (let i = 0; i < 7; i++) {

        const date =
            today.plus({ days: i });

        days.push({

            date:
                date.toFormat(
                    "yyyy-MM-dd"
                ),

            dayName:
                date.toFormat("ccc"),

            dayNum:
                date.toFormat("d"),

            month:
                date.toFormat("LLL"),
        });
    }

    return days;
}